import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { forgotPassword } from '../services/authService';
import Navbar from "../components/landingpage/sections/Navbar";

const ForgotPassword2 = (props) => {
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError("");
        setSuccess("");

        try {
            const response = await forgotPassword(email);

            if (response.success) {
                setSuccess("Password reset OTP sent to your email");
                // Store email for next steps with celebrity identifier
                localStorage.setItem('celebrityResetPasswordEmail', email);
                // Navigate to OTP verification after a short delay
                setTimeout(() => {
                    navigate('/reset-otp2');
                }, 1500);
            }
        } catch (error) {
            setError(error.message || "Failed to send OTP. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
            <>
        <Navbar {...props} />
        <div className="login-content-info">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-4 col-md-6">
                        <div className="account-content">
                            <div className="account-info">
                                <div className="login-title">
                                    <h3>Celebrity Forgot Password</h3>
                                    <p>
                                        Enter your email and we will send you an OTP to reset your
                                        password.
                                    </p>
                                </div>

                                {error && <div className="alert alert-danger">{error}</div>}
                                {success && <div className="alert alert-success">{success}</div>}

                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label className="form-label">Email</label>
                                        <input
                                            className="form-control"
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <button
                                            type="submit"
                                            className="btn btn-primary-gradient w-100"
                                            disabled={isLoading}
                                        >
                                            {isLoading ? "Sending..." : "Submit"}
                                        </button>
                                    </div>
                                    <div className="account-signup">
                                        <p>
                                            Remember Password? <Link to="/celebrity-login">Sign In</Link>
                                        </p>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default ForgotPassword2;